var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerBookingRest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-owner-booking-rest_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M0 17.615h20"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.25,
  d: "M1.539 17.616C1.282 14.026 2.616 6.846 10 6.846s8.717 7.18 8.46 10.77"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M5 13c.128-.641.846-2.154 2.692-3.077"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 4.538,
  r: 1.538,
  fill: "#000"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-owner-booking-rest_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIconOwnerBookingRest;